import React from 'react';
import './CalendlyButton.css';

const CalendlyButton = ({ url, className = '' }) => {
  // Calendly URL
  const calendlyUrl = url || 'https://calendly.com/mary-carpenter-pronurselegal/30min';

  const handleClick = () => {
    window.open(calendlyUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      className={`calendly-button ${className}`}
      onClick={handleClick}
      aria-label="Schedule a consultation"
    >
      Schedule a Consult
    </button>
  );
};

export default CalendlyButton;

